/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { axiosProtectedApi } from './setup';
import store from '@/store';
import qs from 'qs';

export async function validateJwt () {
  const api = axiosProtectedApi(true);
  const device = store.state.AppStore.deviceInfo;
  const deviceInfo = {};
  if (device.deviceid) {
    deviceInfo.deviceid = device.deviceid;
  }
  if (device.os) {
    deviceInfo.os = device.os;
  }
  if (device.osVersion) {
    deviceInfo.osversion = device.osVersion;
  }
  deviceInfo.isweb = false;
  if (device.app) {
    deviceInfo.app = device.app;
  }
  if (device.appVersion) {
    deviceInfo.appversion = device.appVersion;
  }
  if (device.pushToken) {
    deviceInfo.pushnotificationid = device.pushToken;
  }
  if (device.deviceName) {
    deviceInfo.devicename = device.deviceName;
  }
  if (device.modelNo) {
    deviceInfo.modelno = device.modelNo;
  }
  const response = await api.post(
    'login/validatetoken',
    qs.stringify({
      deviceInfo: deviceInfo
    })
  );
  return response && response.data && response.data.status
    ? response.data.status
    : false;
}
